/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  const trigger = event.target.closest(
    '[data-toggle-target], [data-tab-target], [data-modal-target], ' +
      '[data-toggle-reset], [data-toggle-close], [data-close]',
  );

  // Plain background click → maybe close an open data-close-outside toggle
  if (!trigger) {
    handleOutsideClick(event);
    return;
  }

  if (trigger.dataset.toggleTarget) {
    slideToggle(event, trigger);
    return;
  }
  if (trigger.dataset.tabTarget) {
    tabToggle(event, trigger);
    return;
  }
  if (trigger.dataset.modalTarget) {
    modalPop(trigger);
    return;
  }
  if (trigger.hasAttribute('data-toggle-reset')) {
    resetToggles();
    return;
  }
  if (trigger.dataset.toggleClose) {
    closeToggle(trigger.dataset.toggleClose);
    return;
  }
  if (trigger.hasAttribute('data-close')) { 
    if (trigger.dataset.close) closeToggle(trigger.dataset.close);
  }
});

/* ============================================================
 * ESCAPE — closes the toggle flagged on <body>
 * ============================================================ */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const activeToggle = document.body.dataset.close;
  if (activeToggle) closeToggle(activeToggle);
});

/* ============================================================
 * OUTSIDE CLICK — closes the open data-close-outside toggle
 * ============================================================ */
function handleOutsideClick(event) {
  const activeToggle = document.body.dataset.close;
  if (!activeToggle) return;

  // Modal interactions never close slide-toggles
  const openModal = document.querySelector('[data-modal-content].active');
  if (openModal && openModal.contains(event.target)) return;
  if (event.target.closest('[data-close]')) return;

  const content = document.querySelector(
    `[data-toggle-content="${activeToggle}"].active`,
  );
  if (!content) {
    document.body.removeAttribute('data-close');
    return;
  }
  const trigger = document.querySelector(
    `[data-toggle-target="${activeToggle}"]`,
  );
  if (trigger && trigger.contains(event.target)) return;
  if (content.contains(event.target)) return;

  closeToggle(activeToggle);
}

/***************** SLIDE TOGGLES *******************/
function slideToggle(event, trigger) {
  event.preventDefault();

  const target = trigger.dataset.toggleTarget;

  // data-reset: opening this toggle closes every OTHER reset-toggle
  if (trigger.hasAttribute('data-reset')) {
    document
      .querySelectorAll('[data-toggle-target][data-reset]')
      .forEach((other) => {
        if (other === trigger) return;
        closeToggle(other.dataset.toggleTarget);
      });
  }

  document
    .querySelectorAll(`[data-toggle-content="${target}"]`)
    .forEach((group) => {
      if (group.classList.contains('active')) {
        closeToggle(target);
      } else {
        openToggle(target, trigger);
      }
    });
}

function openToggle(target, trigger) {
  document
    .querySelectorAll(`[data-toggle-target="${target}"]`)
    .forEach((toggle) => {
      toggle.classList.add('active');
      toggle.setAttribute('aria-expanded', 'true');
    });

  if (trigger && trigger.hasAttribute('data-close-outside')) {
    document.body.setAttribute(
      'data-close',
      trigger.dataset.closeOutside || target,
    );
  }

  document
    .querySelectorAll(`[data-toggle-content="${target}"]`)
    .forEach((group) => {
      group.setAttribute('aria-hidden', 'false');
      group.classList.add('active');

      // Measure true height
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';

      // Double rAF forces Firefox to register the 0px start state
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          group.style.height = height;
        });
      });

      group.addEventListener(
        'transitionend',
        function handleOpenEnd(e) {
          if (e.target === group && e.propertyName === 'height') {
            group.style.height = 'auto';
          }
        },
        { once: true },
      );
    });
}

// Shared animated close — used by trigger click, Escape, outside
// click, data-toggle-close, and data-toggle-reset
function closeToggle(target) {
  document.body.removeAttribute('data-close');

  document
    .querySelectorAll(`[data-toggle-target="${target}"]`)
    .forEach((toggle) => {
      toggle.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
    });

  document
    .querySelectorAll(`[data-toggle-content="${target}"]`)
    .forEach((group) => {
      if (group.classList.contains('active')) animateClose(group);
    });
}

function resetToggles() {
  document.body.removeAttribute('data-close');

  document.querySelectorAll('[data-toggle-target]').forEach((toggle) => {
    toggle.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
  });
  document.querySelectorAll('[data-toggle-content]').forEach((group) => {
    if (group.classList.contains('active')) animateClose(group);
  });
}

function animateClose(group) {
  // Set explicit height so the CSS transition triggers
  group.style.height = group.offsetHeight + 'px';
  // Force reflow so the browser acknowledges the explicit height
  group.offsetHeight;
  // Double rAF → smooth transition to 0px
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      group.style.height = '0px';
    });
  });

  let handled = false;
  function finalize(e) {
    if (handled) return;
    // Only the height transition on the group itself, not a child
    if (e && (e.target !== group || e.propertyName !== 'height')) return;
    handled = true;
    group.classList.remove('active');
    group.setAttribute('aria-hidden', 'true');
  }
  group.addEventListener('transitionend', finalize, { once: true });
  setTimeout(() => finalize(), 450); // Fallback slightly longer than CSS transition
}

/*************** TAB TOGGLES ***********/
function tabToggle(event, trigger) {
  event.preventDefault();

  const target = trigger.dataset.tabTarget;
  const tabGroup = trigger.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(
    `[data-tab-group="${tabGroup}"]`,
  );
  const isMobileToggle =
    trigger.hasAttribute('data-mobile-toggle') && window.innerWidth < 749;

  if (isMobileToggle) {
    if (trigger.classList.contains('active')) {
      trigger.classList.remove('active');
      document
        .querySelectorAll(
          `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`,
        )
        .forEach((content) => content.classList.remove('active'));
    } else {
      tabGroups.forEach((group) => group.classList.remove('active'));
      trigger.classList.add('active');
      document
        .querySelectorAll(
          `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`,
        )
        .forEach((content) => content.classList.add('active'));
    }
  } else {
    tabGroups.forEach((group) => group.classList.remove('active'));
    trigger.classList.add('active');
    document
      .querySelectorAll(
        `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`,
      )
      .forEach((content) => {
        content.classList.add('active');

        content.querySelectorAll('.bd-slider').forEach((slider) => {
          const sliderData = Flickity.data(slider);
          if (sliderData) sliderData.resize(); // ← null check prevents the crash
        });
      });
  }
}

/* ============================================================
 * MODAL TOGGLING — accepts an Event or a trigger element
 * ============================================================ */
let lastFocusedElement = null;

function modalPop(input) {
  const event =
    input && typeof input.preventDefault === 'function' ? input : null;
  const trigger = event
    ? event.target.closest('[data-modal-target]')
    : input;

  if (event) event.preventDefault();
  if (!trigger) return;

  const isLocked = trigger.dataset.modalLocked === 'true';
  const noOverflow = trigger.dataset.noOverflow === 'true';

  const modalContent = document.querySelector(
    `[data-modal-content="${trigger.dataset.modalTarget}"]`,
  );
  if (!modalContent) {
    console.error('Modal not found:', trigger.dataset.modalTarget);
    return;
  }

  // data-class-add: add one or more classes to the opened modal
  // (space-separated, e.g. data-class-add="no-product compact").
  // Tracked on the element so closeModal removes exactly what was added.
  const classesToAdd = trigger.dataset.classAdd?.trim();
  if (classesToAdd) {
    modalContent._dynamicClasses = classesToAdd.split(/\s+/);
    modalContent.classList.add(...modalContent._dynamicClasses);
  }

  lastFocusedElement = document.activeElement;

  modalContent.setAttribute('tabindex', '-1');
  modalContent.removeAttribute('inert');
  modalContent.removeAttribute('aria-hidden');

  if (!modalContent.hasAttribute('data-no-reposition')) {
    const { originalParent, originalNextSibling } =
      repositionModal(modalContent);
    modalContent._originalParent = originalParent;
    modalContent._originalNextSibling = originalNextSibling;
  }

  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ];
  const focusableElements = Array.from(
    modalContent.querySelectorAll(focusableSelectors.join(',')),
  ).filter((el) => el.offsetParent !== null);

  (focusableElements[0] || modalContent).focus();

  modalContent._trapFocusHandler = createTrapFocusHandler(modalContent);
  document.addEventListener('keydown', modalContent._trapFocusHandler);

  if (!isLocked) {
    modalContent._escapeListener = (e) => {
      if (e.code === 'Escape') closeModal(modalContent);
    };
    window.addEventListener('keyup', modalContent._escapeListener);

    modalContent._outsideClickListener = (evt) => {
      if (evt.target === modalContent) closeModal(modalContent);
    };
    window.addEventListener('click', modalContent._outsideClickListener);
  }

  modalContent
    .querySelectorAll('[data-close]')
    .forEach((btn) =>
      btn.addEventListener(
        'click',
        () => closeModal(modalContent),
        { once: true },
      ),
    );

  modalContent.classList.add('active');
  if (!noOverflow) document.body.classList.add('overflow-hidden');
}

// SINGLE closeModal — drawer handling + quote cleanup, both live here
function closeModal(modal) {
  modal.classList.remove('active');
  document.body.classList.remove('overflow-hidden');

  // Remove any classes injected via the trigger's data-class-add
  if (modal._dynamicClasses) {
    modal.classList.remove(...modal._dynamicClasses);
    delete modal._dynamicClasses;
  }

  if (modal.hasAttribute('data-drawer')) {
    // Drawers are visible page content on desktop — never leave them
    // inert/aria-hidden after a mobile modal session
    modal.removeAttribute('inert');
    modal.removeAttribute('aria-hidden');
  } else {
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('inert', '');
  }

  if (modal._trapFocusHandler) {
    document.removeEventListener('keydown', modal._trapFocusHandler);
    delete modal._trapFocusHandler;
  }
  if (modal._escapeListener) {
    window.removeEventListener('keyup', modal._escapeListener);
    delete modal._escapeListener;
  }
  if (modal._outsideClickListener) {
    window.removeEventListener('click', modal._outsideClickListener);
    delete modal._outsideClickListener;
  }

  if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
    lastFocusedElement.focus();
  }

  const cookie = modal.dataset.cookieModal || false;
  const days = modal.dataset.cookieExpires || 5;
  if (cookie) setCookie(cookie, 'seen', days);

  stopVideos();
  restoreModal(modal, modal._originalParent, modal._originalNextSibling);

  // ---- Product-quote cleanup (guarded, quote modals only) ----
  const productImage = modal.querySelector('[data-product-image] img');
  const productTitle = modal.querySelector('[data-product-title]');
  const quoteDisplayTitle = modal.querySelector('[data-quote-display-title]');

  if (productImage || productTitle || quoteDisplayTitle) {
    localStorage.removeItem('quoteProduct');
    localStorage.removeItem('quoteImageSrc');
    localStorage.removeItem('quoteImageSrcset');
    modal.classList.remove('with-image');
    if (productImage) {
      productImage.src = '';
      productImage.srcset = '';
    }
    if (productTitle) productTitle.value = '';
    if (quoteDisplayTitle) quoteDisplayTitle.innerHTML = '';
  }
}

function stopVideos() {
  document.querySelectorAll('iframe').forEach((v) => {
    v.src = v.src;
  });
  document.querySelectorAll('video').forEach((v) => v.pause());
}

function createTrapFocusHandler(modalContent) {
  return function trapFocusHandler(event) {
    if (event.key !== 'Tab') return;

    const focusableElements = Array.from(
      modalContent.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((el) => el.offsetParent !== null);

    if (focusableElements.length === 0) {
      event.preventDefault();
      return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (focusableElements.length === 1) {
      event.preventDefault();
      firstFocusable.focus();
      return;
    }

    if (event.shiftKey) {
      if (
        document.activeElement === firstFocusable ||
        document.activeElement === modalContent
      ) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else if (document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  };
}

function repositionModal(modal) {
  const originalParent = modal.parentNode;
  const originalNextSibling = modal.nextSibling;
  document.body.appendChild(modal);
  return { originalParent, originalNextSibling };
}

function restoreModal(modal, originalParent, originalNextSibling) {
  if (originalParent) {
    if (originalNextSibling) {
      originalParent.insertBefore(modal, originalNextSibling);
    } else {
      originalParent.appendChild(modal);
    }
  }
  delete modal._originalParent;
  delete modal._originalNextSibling;
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

/* ============================================================
 * LIMIT LISTS
 * ============================================================ */
document.querySelectorAll('ul[data-limit]').forEach((list) => {
  const limit = parseInt(list.getAttribute('data-limit'), 10);
  const items = Array.from(list.querySelectorAll('li'));
  if (items.length <= limit) return;

  const itemsToHide = items.slice(limit);
  itemsToHide.forEach((item) => item.classList.add('hide'));

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'view-more-btn small-size gpa025';
  button.innerHTML = 'View More <span class="btn-arrow">↓</span>';
  list.insertAdjacentElement('afterend', button);

  button.addEventListener('click', () => {
    const isExpanded = button.classList.contains('is-expanded');
    if (isExpanded) {
      itemsToHide.forEach((item) => item.classList.add('hide'));
      button.classList.remove('is-expanded');
      button.innerHTML = 'View All <span class="btn-arrow">↓</span>';
    } else {
      itemsToHide.forEach((item) => item.classList.remove('hide'));
      button.classList.add('is-expanded');
      button.innerHTML = 'View Less <span class="btn-arrow">↑</span>';
    }
  });
});

/* ============================================================
 * DRAWER INIT — one-time fix for fresh desktop loads.
 * Server-rendered drawers ship with inert=""; strip it when
 * we're on desktop where the drawer is always-visible content.
 * ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(min-width: 750px)').matches) return;
  document.querySelectorAll('[data-drawer]').forEach((drawer) => {
    drawer.removeAttribute('inert');
    drawer.removeAttribute('aria-hidden');
    drawer.removeAttribute('tabindex');
  });
});  